/**
 * useFinishedActivitiesParams — ce que la barre de recherche des activités faites envoie au
 * serveur, stable tant qu'elle ne change pas.
 *
 * Le texte tapé attend une courte pause avant de partir : une requête par mot, pas une par
 * lettre. Une puce part tout de suite. Lu par l'écran élève (legacy) et l'espace parent.
 */
import { useEffect, useMemo, useState } from "react"

import { toFinishedActivitiesParams, type FinishedActivitiesParams } from "../formatters/activitySearchFormatter"
import { type UIActivitySearch } from "../types"

const TYPING_PAUSE_MS = 300

export function useFinishedActivitiesParams(search: UIActivitySearch): FinishedActivitiesParams {
    const [query, setQuery] = useState(search.query)

    useEffect(() => {
        // Effacer la recherche ramène la liste complète sans attendre.
        if (search.query.trim() === "") {
            setQuery(search.query)
            return
        }
        const timer = setTimeout(() => setQuery(search.query), TYPING_PAUSE_MS)
        return () => clearTimeout(timer)
    }, [search.query])

    // Un espace en plus ne relance pas la recherche.
    const title = query.trim()
    const { type, subjectId, period } = search
    return useMemo(
        () => toFinishedActivitiesParams({ query: title, type, subjectId, period }),
        [title, type, subjectId, period]
    )
}
